import { sample } from "effector"
import { login, resetErrors, setInputValue } from "./events"
import { authLoginFx } from "./effects"
import { showErrorToastFx } from "../../../shared/lib/notify/showErrorToast"
import { $loginFormStore } from "./store"


sample({
	clock: login,
    source: $loginFormStore,
    filter: (store) => Boolean(
        store.loginInput.isValid &&
        store.passwordInput.isValid
    ),
    fn: (store) => {
        return {
            username: store.loginInput.value,
            password: store.passwordInput.value
        }
    },
	target: authLoginFx
})


sample({
	clock: authLoginFx.failData,
	fn: (error) => error.message,
	target: showErrorToastFx,
})


sample({
    clock: setInputValue,
    source: $loginFormStore,
    filter: (store, input) => Boolean(
        store[input.key].errorMessage
        && !store[input.key].isValid
    ),
    fn: (_, input) => input.key,
    target: resetErrors,
})
